export default "/_next/static/images/71/fun@2x-711870aeb1ddd1781ee046fd7520e263.jpg";